import { render, staticRenderFns } from "./digitalHuman.vue?vue&type=template&id=41435070&scoped=true"
import script from "./digitalHuman.vue?vue&type=script&lang=js"
export * from "./digitalHuman.vue?vue&type=script&lang=js"
import style0 from "./digitalHuman.vue?vue&type=style&index=0&id=41435070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41435070",
  null
  
)

export default component.exports